import { render, staticRenderFns } from "./SearchResultTiledView.vue?vue&type=template&id=6ed13ed8"
import script from "./SearchResultTiledView.vue?vue&type=script&lang=js"
export * from "./SearchResultTiledView.vue?vue&type=script&lang=js"
import style0 from "./SearchResultTiledView.vue?vue&type=style&index=0&id=6ed13ed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports